'use strict';

angular.module('adelementAdminApp')
	.controller('ExcludedFieldDeleteController', function($scope, $uibModalInstance, entity, ExcludedField) {

        $scope.excludedField = entity;
        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        $scope.confirmDelete = function (id) {
            ExcludedField.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };

    });
